"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStatus = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@bluebase/core");
const formik_1 = require("formik");
const react_1 = tslib_1.__importDefault(require("react"));
const react_native_1 = require("react-native");
const FormStatusList = core_1.getComponent('FormStatusList');
const defaultStyles = (theme) => ({
    root: {
        borderRadius: theme.shape.borderRadius,
        borderWidth: 1,
        marginHorizontal: theme.spacing.unit * 2,
    },
    error: {
        backgroundColor: '#ffebee',
        borderColor: theme.palette.error.main,
    },
    warning: {
        backgroundColor: '#fff3e0',
        borderColor: theme.palette.warning.dark,
    },
    success: {
        backgroundColor: '#e8f5e9',
        borderColor: theme.palette.success.main,
    },
});
const FormStatus = (props) => {
    const formik = formik_1.useFormikContext();
    const errors = formik.errors && formik.errors.form;
    const warnings = formik.status && formik.status.warnings;
    const success = formik.status && formik.status.success;
    const styles = core_1.useStyles('FormStatus', props, defaultStyles);
    const statusRootStyles = (type) => {
        const rootStyles = Object.assign({}, styles.root);
        switch (type) {
            case 'error':
                return Object.assign(Object.assign({}, rootStyles), styles.error);
            case 'warning':
                return Object.assign(Object.assign({}, rootStyles), styles.warning);
            case 'success':
                return Object.assign(Object.assign({}, rootStyles), styles.success);
        }
    };
    const getFormStatusList = (type, items) => {
        return !items || !items.length ? null : (react_1.default.createElement(react_native_1.View, { style: statusRootStyles(type), testID: "FormStatusList-view" },
            react_1.default.createElement(FormStatusList, { type: type, items: items })));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        getFormStatusList('success', success),
        getFormStatusList('warning', warnings),
        getFormStatusList('error', errors)));
};
exports.FormStatus = FormStatus;
